import React from 'react';
import ClassAssembly  from 'views/ClassAssembly5D2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;